<div class="container-fluid ptCustom">
    <div class="modal fade memberInfoModal" id="memberInfoModal" tabindex="-1" aria-labelledby="memberInfoModal" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="memberInfoModalTitle">Membership Information</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="mb-3">Membership Ad Packages</div>
                    <div class="">
                        <!-- NEED NEW URLs -->
                        <div class="membershipLink mb-2">
                            <a href="../assets/files/Private100AdPackage.pdf" target="_blank">
                                <i class="fa-solid fa-file-pdf"></i> Private 100 Membership
                            </a>
                            <small *ngIf="membership=='Private 100'" class="fst-italic">current</small>
                        </div>
                        <div class="membershipLink mb-2">
                            <a href="../assets/files/PlatinumAdPackage.pdf" target="_blank">
                                <i class="fa-solid fa-file-pdf"></i> Platinum Membership
                            </a>
                            <small *ngIf="membership=='Platinum'" class="fst-italic">current</small>
                        </div>
                        <div class="membershipLink mb-2">
                            <a href="../assets/files/PremiumAdPackage.pdf" target="_blank">
                                <i class="fa-solid fa-file-pdf"></i> Premium Membership
                            </a>
                            <small *ngIf="membership=='Premium'" class="fst-italic">current</small>
                        </div>
                        <div class="membershipLink">
                            <a href="../assets/files/SignatureAdPackage.pdf" target="_blank">
                                <i class="fa-solid fa-file-pdf"></i> Signature Membership
                            </a>
                            <small *ngIf="membership=='Signature'" class="fst-italic">current</small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col">
            <div class="card shadow-sm rounded-lg submitMemberNews pb-0">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <div class="fs-1">Membership: <span class="fw-bold">{{membership}}</span></div>
                            <button type="button" (click)="openUpgradeModal()" class="btn btn-outline-light text-strong px-4 shadow-sm"><span class="me-2"><i class="fa-regular fa-sparkles"></i></span>Upgrade</button>
                        </div>
                        <div class="row submitMemberNewsWrap p-0">
                            <div *ngFor="let adType of adTypes" class="col-lg-6 mb-3">
                                <div class="detailsSection adMembership">
                                    <div class="adType">
                                        {{adType.name}} <a class="wutDis" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#memberInfoModal"><i class="fa-solid fa-circle-question"></i></a>
                                    </div>
                                    <div class="adUsage">
                                        {{adType.used}} of {{adType.max}} used
                                    </div>
                                    <div *ngIf="adType.used < adType.max" class="mt-3">
                                        <button type="button" class="btn btn-secondary w-100 newsSubmitBtn" [routerLink]="['/admin-portal/member/submit-member-ad/', adType.type]" routerLinkActive="activePage">Submit</button>
                                    </div>
                                    <div *ngIf="adType.used >= adType.max" class="mt-3 submissionsZero">
                                        All submissions used
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <hr />

    <div class="row">
        <div class="col-12 my-2">
            <div class="mb-3">
                <h2><span class="me-2"><i class="fa-regular fa-clock-rotate-left"></i></span> Previous Submissions</h2>
            </div>
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="row align-items-end">
                        <div class="input-group mb-3 mb-xl-0">
                            <input (keyup)="enterSearchTerm($event)" [(ngModel)]='searchText' type="text" class="form-control form-control-lg" placeholder="search pending submissions...">
                            <button class="btn btn-lg btn-db border-lb dropdown-toggle" type="button" id="searchFilter" data-bs-toggle="dropdown" aria-expanded="false">
                                Type: {{typeSearch.display}}
                            </button>
                            <ul class="dropdown-menu" aria-labelledby="searchFilter">
                                <li><a *ngIf="typeSearch.value != 0" (click)="changeTypeSearch(0)" class="dropdown-item" href="javascript:void(0)">All</a></li>
                                <li><a *ngIf="typeSearch.value != 1" (click)="changeTypeSearch(1)" class="dropdown-item" href="javascript:void(0)">Monday Morning Memo</a></li>
                                <li><a *ngIf="typeSearch.value != 2" (click)="changeTypeSearch(2)" class="dropdown-item" href="javascript:void(0)">Monthly Event Notice</a></li>
                                <li><a *ngIf="typeSearch.value != 3" (click)="changeTypeSearch(3)" class="dropdown-item" href="javascript:void(0)">Member Directory Spotlight</a></li>
                            </ul>
                            <button type="button" (click)="hitSearchBtn()" class="btn btn-lg btn-sb border-lb"><i class="fas fa-search"></i></button>
                            <button type="button" (click)="clearSearch()" class="btn btn-lg btn-primary border-lb"><i class="fas fa-times"></i></button>
                        </div>
                        <div class="search-filters py-2">
                            <!-- hide if none -->
                            <ul class="filter-tags" *ngIf="keywordSearches.length > 0">
                                <li (click)="removeSearchTerm(search)" *ngFor="let search of keywordSearches" class="tag">
                                    <span>{{search}}</span><span class="remove-tag"><i class="fa fa-times-circle"></i></span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mt-2 mb-4">
                        <div class="fs-5 fst-italic">viewing {{itemStart}}-{{itemEnd}} of {{filteredAds}} previous submissions</div>
                    </div>
                    <div class="card no-shadow border border-db bg-db p-2">
                        <div class="">
                            <table class="table table-hover align-middle m-0">
                                <thead>
                                    <tr>
                                        <th>
                                            <a (click)="changeSortType(7)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 7}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                                <span [ngClass]="{'active': sortType == 8}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                            </a>Type
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(5)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 5}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                                <span [ngClass]="{'active': sortType == 6}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                            </a>Upload Date
                                        </th>
                                        <th>
                                            <a (click)="changeSortType(9)" class="sort-icons">
                                                <span [ngClass]="{'active': sortType == 9}" class="icon"><i class="far fa-long-arrow-alt-up"></i></span>
                                                <span [ngClass]="{'active': sortType == 10}" class="icon"><i class="far fa-long-arrow-alt-down"></i></span>
                                            </a>Status
                                        </th>
                                        <th class="text-end">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let ad of previousAds">
                                        <td>
                                            {{ad.type}}
                                        </td>
                                        <td>{{CommonLibrary.formatDateIntoString(ad.submissionDate)}}</td>
                                        <td>{{CommonLibrary.formatStatusIntoString(ad.status)}}</td>
                                        <td class="text-end">
                                            <div class="dropdown">
                                                <button class="btn btn-lg btn-outline-dark action-btn" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <i class="far fa-ellipsis-v"></i>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton1">
                                                    <li><a class="dropdown-item" (click)="downloadAdImage(ad)"><i class="fa-light fa-download fa-fw"></i> Download</a></li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <nav aria-label="table navigation" class="d-flex align-items-center justify-content-center">
                            <ngb-pagination class="pagination mb-0" [maxSize]="5" [ellipses]="true"
                                            [collectionSize]="filteredAds"
                                            [(page)]="currentPageNum" [pageSize]="itemsPerPage">
                            </ngb-pagination>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>